export default __webpack_public_path__ + "static/media/icon_people_blue.00642d35.svg";